import { realtyStatusMock } from '../../../data/cardRealty';
import { mockAccordionTitles } from '../../../data/constants';
import { houseTypeData } from '../add-request-mock';

const observationsSelectData = [
  { value: '0', title: 'Abandoned' },
  { value: 1, title: 'Not used' },
  { value: 2, title: 'Needs rebuild' },
  { value: 3, title: 'Needs refreshments' },
  { value: 4, title: 'Renovation in progress' },
  { value: 5, title: 'Abandonded renovation' },
  { value: 6, title: 'Newly rebuilt' },
];

const dpeGesSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'A' },
  { value: 2, title: 'B' },
  { value: 3, title: 'C' },
  { value: 4, title: 'D' },
  { value: 5, title: 'E' },
  { value: 6, title: 'F' },
  { value: 7, title: 'G' },
];

const conditionSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Brand new' },
  { value: 2, title: 'Excellent' },
  { value: 3, title: 'Good' },
  { value: 4, title: 'Needs refreshments' },
  { value: 5, title: 'Needs fully renovation' },
];

const styleSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Modern' },
  { value: 2, title: 'Provencal' },
  { value: 3, title: 'Neo-provencal' },
  { value: 4, title: 'Bourgeois' },
  { value: 5, title: 'Belle epoque' },
  { value: 6, title: 'Florentine' },
];

const viewSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Partial' },
  { value: 2, title: 'Open' },
  { value: 3, title: 'Panoramic' },
  { value: 4, title: 'Vis-a-vis' },
];

const viewWindowSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Countryside' },
  { value: 2, title: 'Sky' },
  { value: 3, title: 'Hills' },
  { value: 4, title: 'Backyard' },
  { value: 5, title: 'Golf' },
  { value: 6, title: 'Garden' },
  { value: 7, title: 'Lake' },
  { value: 8, title: 'Sea' },
  { value: 9, title: 'Mountains' },
  { value: 10, title: 'Park' },
  { value: 11, title: 'Swimming pool' },
  { value: 12, title: 'Skiing track' },
  { value: 13, title: 'Port' },
  { value: 14, title: 'River' },
  { value: 15, title: 'Street' },
  { value: 16, title: 'Village' },
  { value: 17, title: 'City' },
];

const expositionSelectData = [
  { value: '0', title: 'North' },
  { value: 1, title: 'South' },
  { value: 2, title: 'East' },
  { value: 3, title: 'West' },
  { value: 4, title: 'Northwest' },
  { value: 5, title: 'Northeast' },
  { value: 6, title: 'Southwest' },
  { value: 7, title: 'Southeast' },
];

export const hotWaterMeterData = [
  { id: 1, value: '0', title: 'None' },
  { id: 2, value: 1, title: 'Individual meter' },
  { id: 3, value: 2, title: 'Whole building meter' },
];

export const hotWaterTypeData = [
  { id: 1, value: '0', title: 'None' },
  { id: 2, value: 1, title: 'Electric boiler' },
  { id: 3, value: 2, title: 'Solar water heater' },
];

const heatingTypeSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Floor heating' },
  { value: 2, title: 'Central' },
  { value: 3, title: 'By air conditioning' },
  { value: 4, title: 'By convector heater' },
  { value: 5, title: 'Stove' },
  { value: 6, title: 'By radiators' },
  { value: 7, title: 'Without heating' },
  { value: 8, title: 'Boiler' },
];

const heatingFuelSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Wood' },
  { value: 2, title: 'Coal' },
  { value: 3, title: 'Hot water' },
  { value: 4, title: 'Electric' },
  { value: 5, title: 'Fuel/oil/mazut' },
  { value: 6, title: 'Gas' },
  { value: 7, title: 'Geothermal' },
  { value: 8, title: 'Pellet fuels' },
  { value: 9, title: 'Heat pump' },
  { value: 10, title: 'Solar' },
];

const heatingOwnerSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Collective' },
  { value: 2, title: 'Individual meter' },
  { value: 3, title: 'Combined' },
  { value: 4, title: 'Heat network' },
];

const usedWaterSelectData = [
  { value: '0', title: 'None' },
  { value: 1, title: 'Septic tank' },
  { value: 2, title: 'Sewage treatment station' },
  { value: 3, title: 'Public sewers' },
];

const mockTitle = mockAccordionTitles.Main;

export const mainMockValues = {
  realty_status: '',
  urgency_type: '',
  observation_types: '',
  realty_type: '',
  condition_type: '',
  style: '',
  exposition_type: '',
  used_water: '',
  property_name: '',
  living_area: '',
  living_room: '',
  full_area: '',
  kitchen: '',
  land_area: '',
  room: '',
  bedroom: '',
  ceiling_height: '',
  bathroom: '',
  terrace: '',
  floor: '',
  wc: '',
  view_type: '',
  window_view_type: [],
  heating_type: '',
  heating_fuel_type: '',
  heating_owner_type: '',
  dpe: '',
  ges: '',
  vefa: '',
  parking_garage_space: '',
  parking_garage_owners: '',
  parking_parking_space: '',
  parking_parking_owners: '',
  parking_storage_space: '',
  urgent_research: '',
  renovation_date: '',
  construction_date: '',
  hot_water: '',
  meter_type: '',
  apartment_number: '',
};

export const mainMock = [
  {
    title: mockTitle,
    id: 1,
    placeholder: 'Realty status',
    name: 'realty_status',
    fieldType: 'select',
    selectData: realtyStatusMock,
    classNames: 'w-full sm:w-2/4',
  },
  {
    title: mockTitle,
    id: 2,
    checkboxText: 'Urgent research',
    name: 'urgent_research',
    fieldType: 'checkbox',
    classNames: 'w-60 sm:w-80',
  },
  {
    title: mockTitle,
    id: 3,
    placeholder: 'Observations',
    name: 'observation_types',
    fieldType: 'multiselect',
    selectData: observationsSelectData,
    classNames: 'w-full sm:w-2/4',
  },
  {
    title: mockTitle,
    id: 4,
    name: 'realty_type',
    fieldType: 'toggle',
    toggleList: houseTypeData,
    className: 'justify-start gap-0',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 5,
    placeholder: 'Property name',
    name: 'property_name',
    fieldType: 'text',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 6,
    placeholder: 'Living area',
    name: 'living_area',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 7,
    placeholder: 'Full area',
    name: 'full_area',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 8,
    placeholder: 'Terrace',
    name: 'terrace',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 9,
    placeholder: 'Land area',
    name: 'land_area',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 10,
    placeholder: 'Rooms',
    name: 'room',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 11,
    placeholder: 'Living room',
    name: 'living_room',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 12,
    placeholder: 'Kitchens number',
    name: 'kitchen',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 13,
    placeholder: 'Bedrooms number',
    name: 'bedroom',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 14,
    placeholder: 'Bathrooms number',
    name: 'bathroom',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 15,
    placeholder: 'Number WC sep.',
    name: 'wc',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId',
    id: 16,
    placeholder: 'Apartments number',
    name: 'apartment_number',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 17,
    placeholder: 'DPE',
    name: 'dpe',
    fieldType: 'select',
    selectData: dpeGesSelectData,
    classNames: 'w-full sm:w-2/4',
  },
  {
    title: mockTitle,
    id: 18,
    placeholder: 'GES',
    name: 'ges',
    fieldType: 'select',
    selectData: dpeGesSelectData,
    classNames: 'w-full sm:w-2/4',
  },
  {
    title: mockTitle,
    listId: 'listId1',
    subtitle: 'Parking / Garage / Storage',
    id: 19,
    placeholder: 'Parking spaces',
    fieldType: 'text',
    type: 'number',
    name: 'parking_parking_space',
    classNames: 'w-[34%]',
  },
  {
    title: mockTitle,
    listId: 'listId1',
    id: 20,
    fieldType: 'checkboxList',
    name: 'parking_parking_owners',
    checkboxes: [
      {
        id: 1,
        checkboxText: 'Private',
        value: '0',
        name: 'parking_private',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        id: 2,
        checkboxText: 'Public',
        value: 1,
        name: 'parking_owner',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        id: 3,
        checkboxText: 'Residence',
        value: 2,
        name: 'parking_residence',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
    ],
    classNames: 'w-full',
  },
  {
    title: mockTitle,
    listId: 'listId2',
    id: 21,
    placeholder: 'Garages',
    fieldType: 'text',
    type: 'number',
    name: 'parking_garage_space',
    classNames: 'w-[34%]',
  },
  {
    title: mockTitle,
    listId: 'listId2',
    id: 22,
    fieldType: 'checkboxList',
    name: 'parking_garage_owners',
    checkboxes: [
      {
        id: 4,
        checkboxText: 'Private',
        value: '0',
        name: 'garage_private',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        id: 5,
        checkboxText: 'Public',
        value: 1,
        name: 'garage_owner',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        id: 6,
        checkboxText: 'Residence',
        value: 2,
        name: 'garage_residence',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
    ],
    classNames: 'w-full',
  },
  {
    title: mockTitle,
    id: 23,
    placeholder: 'Storage spaces',
    fieldType: 'text',
    type: 'number',
    name: 'parking_storage_space',
    classNames: 'w-[34%]',
  },
  {
    title: mockTitle,
    subtitle: 'Style & floor',
    listId: 'listId3',
    id: 24,
    placeholder: 'Floor',
    fieldType: 'text',
    type: 'number',
    name: 'floor',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 25,
    listId: 'listId3',
    placeholder: 'Conditon',
    name: 'condition_type',
    fieldType: 'select',
    selectData: conditionSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 26,
    listId: 'listId3',
    placeholder: 'Style',
    name: 'style',
    fieldType: 'select',
    selectData: styleSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 27,
    listId: 'listId3',
    placeholder: 'View',
    name: 'view_type',
    fieldType: 'select',
    selectData: viewSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 28,
    listId: 'listId3',
    placeholder: 'Window view',
    name: 'window_view_type',
    fieldType: 'multiselectGrouped',
    selectData: viewWindowSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 29,
    listId: 'listId3',
    placeholder: 'Exposition',
    name: 'exposition_type',
    fieldType: 'multiselect',
    selectData: expositionSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 30,
    listId: 'listId3',
    placeholder: 'Ceiling height',
    name: 'ceiling_height',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 31,
    isBorderTop: true,
    listId: 'listId4',
    placeholder: 'Date of renovation',
    name: 'renovation_date',
    fieldType: 'calendar',
    hasDeleteButton: true,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 32,
    listId: 'listId4',
    placeholder: 'Date of construction',
    name: 'construction_date',
    fieldType: 'calendar',
    hasDeleteButton: true,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 33,
    checkboxText: 'VEFA',
    name: 'vefa',
    fieldType: 'checkbox',
    classNames: 'w-60 sm:w-80',
  },
  {
    title: mockTitle,
    id: 34,
    isBorderTop: true,
    name: 'hot_water',
    fieldType: 'toggle',
    toggleList: hotWaterTypeData,
    toggleTitle: 'Hot water:',
    classNames: 'w-full',
    className: 'justify-start flex-wrap gap-0',
  },
  {
    title: mockTitle,
    id: 35,
    name: 'meter_type',
    fieldType: 'toggle',
    toggleList: hotWaterMeterData,
    classNames: 'w-full',
    className: 'justify-start flex-wrap gap-0',
  },
  {
    title: mockTitle,
    id: 36,
    listId: 'listId5',
    placeholder: 'Heating',
    name: 'heating_type',
    fieldType: 'select',
    selectData: heatingTypeSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 37,
    listId: 'listId5',
    placeholder: 'Heating',
    name: 'heating_fuel_type',
    fieldType: 'select',
    selectData: heatingFuelSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 38,
    listId: 'listId5',
    placeholder: 'Heating',
    name: 'heating_owner_type',
    fieldType: 'select',
    selectData: heatingOwnerSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    id: 39,
    listId: 'listId5',
    placeholder: 'Used water',
    name: 'used_water',
    fieldType: 'select',
    selectData: usedWaterSelectData,
    classNames: 'w-[47%] sm:w-[30%]',
  },
];
